import { createFileRoute } from '@tanstack/react-router';

import { getTechnologicalTransferOptions } from '@/module/Author/TechnologicalTransfer';

export const Route = createFileRoute(
  '/_auth/author/_author/technological-transfer/_technologicalTransfer/$technologicalTransferId/_layout',
)({
  loader: async ({ params: { technologicalTransferId }, context: { queryClient } }) => {
    const technologicalTransfer = await queryClient.ensureQueryData(
      getTechnologicalTransferOptions(technologicalTransferId),
    );

    return {
      technologicalTransfer,
      crumb: technologicalTransfer.title,
    };
  },
});
